import {get} from 'lodash-es'

import {DEFAULT_ITEMS_PER_PAGE} from '~/constants/app.constant'

const getPaginationData = (getResult, countPath, page, itemsPerPage = DEFAULT_ITEMS_PER_PAGE) => {
  const count = get(getResult, countPath) || 0
  const pageCount = count / itemsPerPage
  const canPrev = page <= Math.ceil(pageCount) && page > 1
  const canNext = page < Math.ceil(pageCount)

  return {
    count,
    pageCount,
    canPrev,
    canNext,
  }
}

export default getPaginationData
